import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";

const LocationCtx = createContext(null);

export function LocationProvider({ children }) {
  const [locations, setLocations] = useState([]);
  const [selected, setSelected] = useState(() => localStorage.getItem("bakery_location") || "");

  useEffect(() => {
    api.get("/locations").then((r) => setLocations(r.data)).catch(() => {});
  }, []);

  const setLocation = useCallback((id) => {
    if (id) localStorage.setItem("bakery_location", id);
    else localStorage.removeItem("bakery_location");
    setSelected(id || "");
  }, []);

  // Returns axios `params` object. Stable reference per `selected` change.
  const params = useCallback(
    (extra = {}) => (selected ? { location_id: selected, ...extra } : { ...extra }),
    [selected]
  );

  const refresh = useCallback(async () => {
    const { data } = await api.get("/locations");
    setLocations(data);
  }, []);

  const value = useMemo(
    () => ({ locations, selected, setLocation, params, refresh }),
    [locations, selected, setLocation, params, refresh]
  );

  return <LocationCtx.Provider value={value}>{children}</LocationCtx.Provider>;
}

export const useLocations = () => useContext(LocationCtx);
